// Global Instructions Rule Applied!

import { PipelineState, DealState, MainState } from '../interfaces/deals.ts'

export type { FilterValue, SortConfig } from '../interfaces/deals.ts'
export { DealTarget } from '../interfaces/deals.ts'
export type { MainState, PipelineState, DealState } from '../interfaces/deals.ts'

const pipelineState: PipelineState = {
  filterOptions: {
    data: {}
  },
  activeFilters: [],
  activeSorting: [],
  data: []
}

const dealState: DealState = {
  filterOptions: {
    data: {}
  },
  activeFilters: [],
  activeSorting: [],
  data: []
}

const mainState: MainState = {
  pipeline: pipelineState,
  deal: dealState
}
